<template>
  <div class="container">
    <div class="show_data_box">
      <div class="header">
        <div class="title">观众特征总结</div>
      </div>
      <div class="audience_characteristics">
        <div class="item_list" v-for="item in audienceCharacteristics" :key="item.id">
          <div class="img_box">
            <img :src="item.icon" alt="">
          </div>
          <div class="data_box">
            <div class="name">{{video_id==1? item.name1 :item.name2}}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>

      </div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="tip_list">观众区域 <span style="margin-left: 10px; color: #bebec1;">每20分钟更新</span></div>
      <div class="tip_box">广东最多,相比大盘均值浙江占比更显著</div>
      <div class="flowEachrts" ref="audiencePreferenceRef"></div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="tip_list">观众城市等级 <span style="margin-left: 10px; color: #bebec1;">每20分钟更新</span></div>
      <div class="tip_box">三线最多,相比大盘均值一线占比更显著</div>
      <div class="flowEachrts" ref="audienceCityClassRef"></div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="tip_list">观众性别 <span style="margin-left: 10px; color: #bebec1;">每20分钟更新</span></div>
      <div class="tip_box">{{video_id==1?"女性最多,相比大盘均值女性占比更显著":"男性最多，相比大盘均值男性占比更显著"}}</div>
      <div class="sex_progress">
        <el-progress style="margin: 10px 0;" :percentage="video_id==1?9.57:90.45" color="#6a75f6" define-back-color="#da637c"></el-progress>
      </div>
      <div class="legend"><span class="circle" style="background: #6a75f6;"></span>男性{{video_id==1?9.57:90.45}}% <span style="color: #e5e5e9;">|</span> 目标群体指数: {{video_id==1?17.3:160.3}}</div>
      <div class="legend"><span class="circle" style="background: #da637c;"></span>女性{{video_id==1? 90.43:9.55}}% <span style="color: #e5e5e9;">|</span> 目标群体指数: {{video_id==1?203.1:21.9}}</div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="tip_list">观众年龄 <span style="margin-left: 10px; color: #bebec1;">每20分钟更新</span></div>
      <div class="tip_box">18-23最多,相比大盘均值18一下占比更显著</div>
      <div class="flowEachrts" ref="audienceAgeRef"></div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="header">
        <div class="title">观众职业</div>
        <div class="tip">每日更新</div>
      </div>
      <div class="table_header" v-for="item in audienceOccupation" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="video_id==1?item.proportion1:item.proportion2" color="#6a75f6"></el-progress>
        </div>
      </div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="header">
        <div class="title">观众新老用户</div>
        <div class="tip">每日更新</div>
      </div>
      <div class="sex_progress">
        <el-progress style="margin: 10px 0;" :percentage="video_id==1?99.71:99.49" color="#da637c" define-back-color="#da637c"></el-progress>
      </div>
      <div class="legend_box">
        <div class="item" style="color: #da637c;"><span style="background: #da637c;" class="circle"></span>老用户99.71%</div>
        <div class="item" style="color: #6a75f6;"><span style="background: #6a75f6;" class="circle"></span>新用户0.51%</div>
      </div>
    </div>
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="header">
        <div class="title">观众活跃情况</div>
        <div class="tip">每20分钟更新</div>
      </div>
      <div class="table_header" v-for="item in audienceActivity" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="video_id==1?item.proportion1:item.proportion2" color="#6a75f6"></el-progress>
        </div>
      </div>
    </div>
    <div class="view_more">
      探索更多创作灵感<i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>
      
  <script>
import {
  spectatorArea,
  audienceCityClass,
  AudienceAge,
} from "./js/Operatingdata";
export default {
  data() {
    return {
      video_id: this.$route.query.video_id,
      audienceCharacteristics: [
        {
          id: 1,
          icon: require("../../assets/img/auAnalysis/icon1.png"),
          name1: "女性、18-23岁居多",
          name2: "男性、18-23岁居多",
          value: "性别年龄",
        },
        {
          id: 2,
          icon: require("../../assets/img/auAnalysis/icon2.png"),
          name1: "三线、广东居多",
          name2: "三线、广东居多",
          value: "地域",
        },
        {
          id: 3,
          icon: require("../../assets/img/auAnalysis/icon3.png"),
          name1: "在校大学生居多",
          name2: "在校大学生居多",
          value: "兴趣职业",
        },
      ],
      audienceSex: [
        {
          id: 1,
          male: 9.57,
          female: 90.43,
          maleValue: 17.3,
          femaleValue: 203.1,
          tip: "女性最多，相比大盘均值女性占比更显著",
        },
        {
          id: 2,
          male: 90.45,
          female: 9.55,
          maleValue: 160.3,
          femaleValue: 21.9,
          tip: "男性最多，相比大盘均值男性占比更显著",
        },
      ],
      audienceOccupation: [
        {
          name: "在校大学生",
          proportion1: 31.57,
          proportion2: 34.84,
        },
        {
          name: "服务业",
          proportion1: 19.47,
          proportion2: 14.98,
        },
        {
          name: "非工作人员",
          proportion1: 17.43,
          proportion2: 14.74,
        },
        {
          name: "制造业",
          proportion1: 9.8,
          proportion2: 13.23,
        },
        {
          name: "白领",
          proportion1: 8.56,
          proportion2: 10.06,
        },
      ],
      audienceActivity: [
        {
          name: "重度",
          proportion1: 79.79,
          proportion2: 73.3,
        },
        {
          name: "中度",
          proportion1: 13.52,
          proportion2: 18.87,
        },
        {
          name: "轻度",
          proportion1: 1.28,
          proportion2: 1.18,
        },
        {
          name: "低活",
          proportion1: 0.45,
          proportion2: 0.39,
        },
      ],
      spectatorAreaData: {},
      audienceCityClassData: {},
      AudienceAgeData: {},
    };
  },
  mounted() {
    this.spectatorAreaData = spectatorArea[this.video_id - 1];
    this.getAudienceEcharts(1, this.spectatorAreaData);
    this.audienceCityClassData = audienceCityClass[this.video_id - 1];
    this.AudienceAgeData = AudienceAge[this.video_id - 1];
    this.getAudienceEcharts(2, this.audienceCityClassData);
    this.getAudienceEcharts(3, this.AudienceAgeData);
  },

  methods: {
    getAudienceEcharts(type, data) {
      let chart = null;
      if (type == 1) {
        chart = this.$echarts.init(this.$refs.audiencePreferenceRef);
      } else if (type == 2) {
        chart = this.$echarts.init(this.$refs.audienceCityClassRef);
      } else {
        chart = this.$echarts.init(this.$refs.audienceAgeRef);
      }
      var xData = data.xData;
      var y1Data = data.y1Data;
      var y2Data = data.y2Data;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: true, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 10,
          left: 5,
          right: 5,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            show: false, // 不显示 y 轴
          },
          {
            type: "value",
            show: false, // 不显示 y 轴
          },
        ],
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#577cf7", // 柱状图颜色
            },
            barWidth: 20,
          },
          {
            name: "目标群体指数",
            type: "line",
            data: y2Data,
            yAxisIndex: 1, // 使用第二个 Y 轴
            itemStyle: {
              color: "#da637c", // 折线颜色
            },
            lineStyle: {
              color: "#da637c", // 折线颜色
            },
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
  },
};
</script>
      
<style scoped lang="scss">
.container {
  width: 100%;
  margin-top: 10px;
  .show_data_box {
    padding: 10px 10px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 5px;
      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .tip {
        font-size: 12px;
        color: #b3b3b7;
      }
    }
    .legend_box {
      display: flex;
      justify-content: space-between;
      .item {
        .circle {
          width: 8px;
          height: 8px;
          border-radius: 100%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    .table_header {
      display: flex;
      margin-top: 10px;

      .name {
        width: 25%;
      }
      .compare {
        width: 75%;
        text-align: right;
        margin-right: 4px;
      }
      .proportion {
        width: 75%;
        text-align: left;
        margin-right: 4px;
      }
    }
    .audience_characteristics {
      .item_list {
        display: flex;
        padding: 10px 0;
        align-items: center;
        .img_box {
          width: 48px;
          height: 48px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .data_box {
          margin-left: 10px;
          .value {
            margin-top: 5px;
            color: #8a8a90;
          }
        }
      }
    }
    .tip_list {
      color: #7680f6;
      font-size: 14px;
      margin-top: 6px;
    }
    .tip_box {
      font-size: 14px;
      color: #8d8e93;
      margin-top: 5px;
    }
    .flowEachrts {
      width: 100%;
      height: 200px;
    }
    .legend {
      padding: 5px 0;
      color: #6d6f75;
      .circle {
        width: 8px;
        height: 8px;
        border-radius: 100%;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .view_more {
    margin: 20px 0;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 15px;
    .el-icon-arrow-right {
      color: #333;
      font-weight: 600;
      font-size: 18px;
      margin-top: 2px;
    }
  }
}
.sex_progress {
  ::v-deep .el-progress-bar__outer {
    height: 15px !important;
    border-radius: 0px !important;
    background-color: #da637c;
  }
  ::v-deep .el-progress-bar__inner {
    border-radius: 0px !important;
  }
  ::v-deep .el-progress__text {
    display: none;
  }
  ::v-deep .el-progress-bar {
    padding-right: 0px;
  }
}
.sex_progress {
  ::v-deep .el-progress-bar__outer {
    height: 15px !important;
    border-radius: 0px !important;
    background-color: #6a75f6;
  }
}
.proportion {
  ::v-deep .el-progress-bar__outer {
    height: 15px !important;
    border-radius: 0px !important;
    background-color: #ebeef5;
  }
  ::v-deep .el-progress-bar__inner {
    border-radius: 0px !important;
  }
  ::v-deep .el-progress__text {
    font-size: 13px !important;
  }
}
</style>
      